export default "__VITE_ASSET__3FYfP6QY__$_?url__"